import React, { useEffect, useState } from "react";
import ModalComponent from "../../components/modalComponent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextInput from "../../components/textInput";
import SelectInput from "../../components/selectInput";
import {
  status_select,
  transformToSelectData,
  transformToSelectDataByKey
} from "../../utils/selectsValues";
import {
  callApiAsync,
  GetBussinessUnitsActiveSelect,
  GetUsersByEnterprice
} from "../../services/apiService";
import ButtonComponent from "../../components/button";
import icons from "../../constants/icons";
import SearchableSelectInput from "../../components/selectInput/searchableSelectInput";

const CreateupdateUserApiModal = ({
    rowData,
    open,
    onClose,
    onSubmitFuntion
  }) => {
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [bussinesUnit, setBussinesUnit] = useState([]); 
    const [userList, setUserList] = useState([]); 
    
    const [userSelect, setUserSelect] = useState([]);
  
    const getBussinesUnitSelect = () => {
      callApiAsync(GetBussinessUnitsActiveSelect, (data) => {
        const bussinesUnit = transformToSelectDataByKey(data);
        setBussinesUnit(bussinesUnit);
      });
    };
  const getUserSelect = (enterpriseKey) => {
      callApiAsync(
        () => GetUsersByEnterprice(enterpriseKey),
        (data) => {
          const userList = transformToSelectData(data);
          setUserList(userList);
        }
      );
    };
  
    useEffect(() => {
        getBussinesUnitSelect();
    }, []);
  
    const createSchema = yup.object().shape({
      enterpriseKey: yup.string().required("Selecciona una unidad de negocio"),
      userId: yup.string().required("Selecciona un usuario"),
    });
  
    const editSchema = yup.object().shape({
      enterpriseKey: yup.string().required("Selecciona una unidad de negocio"),
      userId: yup
        .string()
        .required("Selecciona un usuario"),
      state: yup.string().required("Selecciona un estado")
    });
  
    const schema = rowData?.id ? editSchema : createSchema;
  
    const { control, handleSubmit, reset, watch } = useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        enterpriseKey: rowData?.enterpriseKey || "",
        userId: rowData?.userId || "",
        apikey:rowData?.apiKey || "",
        state: rowData?.state || "",
      }
    });

    const enterpriseKeyWatch = watch('enterpriseKey')
  
    useEffect(() => {
      if (open) {
        reset({
          apiKey: rowData?.apiKey || "",
          userId: rowData?.userId || "",
          enterpriseKey: rowData?.enterpriseKey,
          state: rowData?.state ?? 1
        });
      }
    }, [open, rowData, reset]);

    useEffect(() => {
      if (!enterpriseKeyWatch) return
        getUserSelect(enterpriseKeyWatch)
      console.log('enterpriseKeyWatch', enterpriseKeyWatch) 
    }, [enterpriseKeyWatch])
    
  
    const handleClose = () => {
      // setOpenCreate(false);
      // setOpenCreateBillingUnit(false);
    };
  
    const handleFormSubmit = (formData) => {
      console.log(formData)
      rowData?.id
        ? onSubmitFuntion({ id: rowData?.id, ...formData })
        : onSubmitFuntion({ id: 0, ...formData });
      reset();
      onClose();
    };
  
    
  
    return (
      <div>
        <ModalComponent
          open={open}
          onClose={onClose}
          onSubmit={handleSubmit(handleFormSubmit)}
          title={
            rowData?.id ? "Editar clave de api" : "Crear clave de api"
          }
        >
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="HContainer mt-10">
            <SearchableSelectInput
                name="enterpriseKey"
                control={control}
                label="Laboratorio a asociar"
                options={bussinesUnit}
                
            />
            </div>
            <div className="HContainer mt-10">
              <SearchableSelectInput
                name="userId"
                control={control}
                label="Usuario"
                options={userList}
                margin="20px 0 0 0 "
               
              />
            </div>
            {rowData?.id && (
              <div className="HContainer mt-20">
                <SelectInput
                  name="state"
                  control={control}
                  label="Estado"
                  options={status_select}
                  defaultValue={rowData.state ?? 1}
                />
              </div>
            )}
            <div className="HContainer j-center mt-20">
              <ButtonComponent
                type="submit"
                backgroundColor="#F6C079"
                textColor="#000000"
                width="160px"
              >
                Guardar
              </ButtonComponent>
            </div>
          </form>
        </ModalComponent>
      </div>
    );
  };
export default CreateupdateUserApiModal;